import gql from 'graphql-tag';

const filter = JSON.stringify({
  operation: 'OR',
  properties: [
    {
      column: 'product',
      op: 'eq',
      value: 'aap',
    },
    {
      column: 'product',
      op: 'eq',
      value: 'all',
    },
  ],
}).replace(/"/g, '\\"');

export const getAnnouncements = gql`
  query($instId: String!) {
    institutions(instID: $instId) {
      announcements(filter: "${filter}") {
        id
        inst_id
        product
        severity
        title
        subtext
        persistence
        status
        start_date
        end_date
      }
    }
  }
`;

export default getAnnouncements;
